import { render } from "./SmStampProperties.vue?vue&type=template&id=ec2b843c&scoped=true"
import script from "./SmStampProperties.vue?vue&type=script&lang=js"
export * from "./SmStampProperties.vue?vue&type=script&lang=js"

import "./SmStampProperties.vue?vue&type=style&index=0&id=ec2b843c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec2b843c"]])

export default __exports__